<template>
  <div class="">
    <h1 v-if="font_type == 1" class="text-center mtext mb-3">
      The Educators Empowering IGCSE Success
    </h1>
    <h1 v-if="font_type == 2" class="text-center mtext mb-5" style="line-height: 40px;">
      IGCSE အောင်မြင်မှုများအား ပုံဖော်ပေးနေသည့် ပညာရှင်များ
    </h1>
  </div>
  <div class="row justify-content-start align-items-start gx-md-3">
    <div v-for="(data, index) in data3" :key="data"
      :class="`col-md-6 col-lg-4 d-flex justify-content-center ${index == data3.length - 1 ? '' : 'mb-3'}`"
      style="height: 475px;">
      <div data-property-1="5" :id="'igcse-teacher-' + data.id + '-1'" class="single-img">
        <img class="image"
          :src="data.teacher_photo_path ? this.link + '/schooldata/teacherphoto/' + data.teacher_photo_path : 'https://backend.smkedugroup.com/schooldata/teacherphoto/Dr.KyawMinnHtin.jpg'" />
        <div class="overlay-effect"></div>
        <div class="text-overlay">
          <div class="text-overlay-title">
            {{ data.name ? data.name : "Dr. Kyaw Minn Htin" }}
            <br />
          </div>
          <div class="text-overlay-position">
            {{ data.position ? data.position : "History & Social Studies" }}
          </div>
        </div>
        <div class="img-overlay">
          <div class="overlay-title">
            {{ data.name ? data.name : "Dr. Kyaw Minn Htin" }}
          </div>
          <div v-if="displayedContent[data.id]?.currentPage == 0" class="overlay-description"
            v-html="displayedContent[data.id]?.message[displayedContent[data.id]?.currentPage]"></div>
          <div v-else class="overlay-description">
            {{ displayedContent[data.id]?.message[displayedContent[data.id]?.currentPage] }}
            <span v-if="displayedContent[data.id]?.isDisplayNext">...</span>
          </div>
          <div class="go-back-icons">
            <svg v-if="displayedContent[data.id]?.isDisplayPrevious" @click="handlePreviousClick(data)" width="30"
              height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
              <path
                d="M14.931 18.772L13.0456 20.6573L7.38697 15L13.0443 9.34268L14.9296 11.2293L12.4936 13.6667H22.543V16.3333H12.4936L14.931 18.772Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M4.62966 25.3707C-1.09834 19.6427 -1.09834 10.3573 4.62966 4.62934C10.3577 -1.09866 19.643 -1.09866 25.371 4.62934C31.099 10.3573 31.099 19.6427 25.371 25.3707C19.643 31.0987 10.3577 31.0987 4.62966 25.3707ZM6.51499 23.4853C5.40068 22.371 4.51676 21.0482 3.9137 19.5922C3.31064 18.1363 3.00025 16.5759 3.00025 15C3.00025 13.4241 3.31064 11.8637 3.9137 10.4078C4.51676 8.95187 5.40068 7.62899 6.51499 6.51468C7.6293 5.40037 8.95218 4.51645 10.4081 3.91339C11.864 3.31033 13.4245 2.99994 15.0003 2.99994C16.5762 2.99994 18.1366 3.31033 19.5926 3.91339C21.0485 4.51645 22.3713 5.40037 23.4857 6.51468C25.7361 8.76513 27.0004 11.8174 27.0004 15C27.0004 18.1826 25.7361 21.2349 23.4857 23.4853C21.2352 25.7358 18.1829 27.0001 15.0003 27.0001C11.8177 27.0001 8.76544 25.7358 6.51499 23.4853Z"
                fill="white" />
            </svg>

            <svg v-if="displayedContent[data.id]?.isDisplayNext" @click="handleNextClick(data)" width="30" height="30"
              viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer;">
              <path
                d="M15.069 18.5467L16.9544 20.432L22.613 14.7747L16.9557 9.11734L15.0704 11.004L17.5064 13.4413H7.45703V16.108H17.5064L15.069 18.5467Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M25.3703 25.1453C31.0983 19.4173 31.0983 10.132 25.3703 4.404C19.6423 -1.324 10.357 -1.324 4.62901 4.404C-1.09899 10.132 -1.09899 19.4173 4.62901 25.1453C10.357 30.8733 19.6423 30.8733 25.3703 25.1453ZM23.485 23.26C24.5993 22.1457 25.4832 20.8228 26.0863 19.3669C26.6894 17.911 26.9997 16.3505 26.9997 14.7747C26.9997 13.1988 26.6894 11.6384 26.0863 10.1824C25.4832 8.72652 24.5993 7.40364 23.485 6.28933C22.3707 5.17502 21.0478 4.29111 19.5919 3.68805C18.136 3.08499 16.5755 2.77459 14.9997 2.77459C13.4238 2.77459 11.8634 3.08499 10.4074 3.68805C8.95153 4.29111 7.62865 5.17503 6.51434 6.28934C4.26389 8.53979 2.9996 11.5921 2.9996 14.7747C2.9996 17.9573 4.26389 21.0096 6.51434 23.26C8.76479 25.5105 11.8171 26.7747 14.9997 26.7747C18.1823 26.7747 21.2346 25.5105 23.485 23.26Z"
                fill="white" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data3: {
      default: [],
    },
  },

  data() {
    return {
      link: "https://backend.smkedugroup.com",
      // link: "http://localhost:8000",
      displayedContent: {},
    }
  },

  methods: {
    handleNextClick(data) {
      const contentData = this.displayedContent[data.id]
      const contentLen = contentData.message?.length
      if (data.currentPage >= contentLen - 1) return

      const currentPage = contentData.currentPage + 1
      this.displayedContent[data.id] = {
        ...contentData,
        currentPage: currentPage,
        isDisplayPrevious: true,
        isDisplayNext: currentPage != contentLen - 1,
      }
    },

    handlePreviousClick(data) {
      const contentData = this.displayedContent[data.id]
      const contentLen = contentData.message?.length
      if (data.currentPage <= 0) return

      const currentPage = contentData.currentPage - 1
      this.displayedContent[data.id] = {
        ...contentData,
        currentPage: currentPage,
        isDisplayPrevious: currentPage != 0,
        isDisplayNext: true,
      }
    },

    chunkContent(content) {
      const perPage = 650
      let chunks = []
      const total = content?.length || 0;
      let i = 0;

      while (i < total) {
        chunks.push(content.slice(i, i + perPage));
        i += perPage;
      }

      return chunks
    },
  },

  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },

  watch: {
    data3(newData) {
      newData.forEach(each => {
        let contentArray = [each.studied]
        contentArray.push(
          ...this.chunkContent(each.message)
        )

        this.displayedContent = {
          ...this.displayedContent,
          [each.id]: {
            currentPage: 0,
            isDisplayNext: contentArray?.length > 1,
            isDisplayPrevious: false,
            message: contentArray,
          }
        }
      })
    }
  },

  mounted() {
    this.data3.forEach(each => {
      let contentArray = [each.studied]
      contentArray.push(
        ...this.chunkContent(each.message)
      )

      this.displayedContent = {
        ...this.displayedContent,
        [each.id]: {
          currentPage: 0,
          isDisplayNext: contentArray?.length > 1,
          isDisplayPrevious: false,
          message: contentArray,
        }
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.single-img {
  position: relative;
  float: left;
  margin: 0 1%;
  // max-width: 289px;
  width: 100%;
  height: 425px;
  position: relative;
  border-radius: 10px;
  object-fit: cover;

  @include breakpoint(medium) {
    height: 457px;
    max-width: 350px;
  }
}

.image {
  display: block;
  width: 100%;
  height: 425px;
  left: 0px;
  top: 0px;
  position: absolute;
  border-radius: 10px;
  object-fit: cover;
  transition: .3s ease;

  @include breakpoint(medium) {
    height: 457px;
  }
}

.overlay-effect {
  width: 100%;
  height: 20%;
  left: 0px;
  top: 80%;
  position: absolute;
  opacity: 0.80;
  background: linear-gradient(0deg, black 0%, rgba(0, 0, 0, 0) 100%);
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.text-overlay {
  // max-width: 289px;
  width: 100%;
  left: 0;
  bottom: 0;
  position: absolute;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 9px;
  display: inline-flex;
  height: 20%;
  transition: .3s ease;
  overflow: hidden;
  color: white;
}

.text-overlay-title {
  align-self: stretch;
  height: 17.97px;
  font-size: 16px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
}

.text-overlay-position {
  align-self: stretch;
  height: 16.47px;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 22px;
  word-wrap: break-word;
}

.single-img:hover .text-overlay {
  height: 0;
}

.img-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(115, 56, 103, 0.5);
  overflow: hidden;
  width: 100%;
  height: 0;
  transition: .5s ease;
  color: #fff;
  border-radius: 10px;
  text-align: left;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
}

.single-img:hover .img-overlay {
  height: 100%;
}

.overlay-title {
  padding: 1.5rem 1.3rem 0.3rem 1.3rem;
  font-family: Poppins;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.5px;
}

.overlay-description {
  padding: 0.1rem 1.3rem;
  color: #fff;
  font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: justify;
  word-break: break-all;
}

.go-back-icons {
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 2rem;
  padding: 0.8rem 1rem;
}

@media (max-width: 768px) {

  .single-img,
  .image,
  .text-overlay,
  .img-overlay {
    // width: 289px;
  }
}
</style>
